window.okeReviewsWidgetOnInit = function () {
  	setupAggregateSection();
  
    const warButton = document.querySelector('.okeReviews-reviewsWidget-header-controls-writeReview:not(.is-okeReviews-hidden)');
    const controlsSelect = document.querySelector('.okeReviews-reviews .okeReviews-reviews-controls-sort');
    if (warButton && controlsSelect) {
        controlsSelect.insertAdjacentElement("afterbegin", warButton);
    }
};

function setupAggregateSection() {
  const customAggregate = document.querySelector('.okeReviews-custom-aggregate');
  const reviewAggregateSummary = document.querySelector('.okeReviews-reviewsAggregate-side-inner');
  if (customAggregate && reviewAggregateSummary) {
    customAggregate.insertAdjacentElement("afterbegin", reviewAggregateSummary);
  }
  changeText();
}

function changeText() {
  const reviewsTotal = document.querySelector('.okeReviews-reviewsAggregate-summary-total');
  if (reviewsTotal) {
    console.log(reviewsTotal.innerText.replace(/Based on\b\s/g, "")) 
    reviewsTotal.innerText = reviewsTotal.innerText.replace('Based On', '');
  }
}
